import * as React from "react"
import * as ReactDOM from "react-dom";
import { BrowserRouter } from 'react-router-dom';
import { Container } from "semantic-ui-react"

import 'semantic-ui-css/semantic.min.css';
import { Route } from "react-router";
import MainPage from "./Main/MainPage";
import AdminPage from "./Admin/Admin";

class CanISaveMySpace extends React.Component<null, null> {
	render() {
		return (
			<BrowserRouter>
				<Container>
					<Route path="/" exact component={MainPage} />
					<Route path="/admin" exact component={AdminPage} />					
				</Container>
			</BrowserRouter>
		);
	}
}

ReactDOM.render(<CanISaveMySpace />, document.getElementById("app"));


// WEBPACK FOOTER //
// ./src/index.tsx